import React from "react";
import { isMobile } from "utils/session";
import { Textarea } from "@chakra-ui/textarea";

interface FreeResponseTextProps {
  //have this be a value that's passed in once the parent component retrieves any saved responses
  messageBody: string;
  //pass this in as the equivalent of setMessageBody
  onMessageBodyChange: any;
  //pass in the send message function from the parent component
  saveMessage: any;
  toggleGameLiftStreamsInput: any;
}

const FreeResponseText: React.FC<FreeResponseTextProps> = ({ messageBody, onMessageBodyChange, saveMessage, toggleGameLiftStreamsInput }) => {

  // ensures pressing enter + shift creates a new line, so that enter on its own only sends the message:
  const handleReturnKeyPress = (event: React.KeyboardEvent) => {
    if (!isMobile && event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      /* handleSendMessage(messageBody); */
    }
  };

  const handleMessageBodyChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    onMessageBodyChange(event.target.value);
  };

  return (
    <Textarea
      borderRadius="10px"
      aria-label="input for free response option"
      fontSize="16px"
      minHeight="150px"
      onKeyPress={handleReturnKeyPress}
      onChange={handleMessageBodyChange}
      placeholder="Type an observation... (press Shift + Enter to start a new line)"
      defaultValue={messageBody}
      resize="none"
      data-cy-chat-input
      onBlur={(event) => saveMessage(event.target.value)}
      onClick={() => toggleGameLiftStreamsInput(false)}>
    </Textarea>
  );

};

export default FreeResponseText;
